import Axios from 'axios';
import { URL_PLUGIN } from '../parametros';

const onThen = (response) => response;
const onCatch = ({ response }) => response;

export const uploadFile = async (body) => {
  return Axios.post(`${URL_PLUGIN}subir-imagen`, JSON.stringify(body), {

  })
    .then(onThen)
    .catch(onCatch);
};
